// extracted by mini-css-extract-plugin
export default {"root":"FallbackPage_root__VWZFf","content":"FallbackPage_content__J2gvN"};